<template>
  <v-row justify="center" class="feedback-form">
    <v-col cols="12">
      <v-card
        class="pa-sm-5 mt-sm-4 mx-auto"
        :outlined="!_includes(['xs', 'sm'], $mq)"
        flat
        max-width="550px"
      >
        <v-card-title>
          <h1>{{ success ? `Thanks.` : `How can Minimart do better?` }}</h1>
        </v-card-title>
        <v-card-text>
          <transition name="fade" mode="out-in">
            <div v-if="success"
              ><h3 class="mb-3">
                We appreciate you sharing your thoughts. We've received your
                feedback and will be in touch if a follow up was requested.
              </h3>

              <v-btn
                color="blue"
                @click="resetForm"
                depressed
                class="white--text mr-2"
                >Ok, great.</v-btn
              >
              <v-btn color="blue" to="/menu" depressed outlined
                >View the Menu</v-btn
              >
            </div>
            <v-form
              v-else
              v-model="isFormValid"
              ref="form"
              @submit.prevent="submitAction"
              :disabled="isSending"
            >
              <div class="text-h5 font-italic font-weight-bold"
                >Your message will be sent to the creators of Minimart, not the
                owner of this store. For specific questions regarding
                {{ getShopTitle }}, please email the owner at
                <a :href="`mailto:${getContactEmail}`">{{ getContactEmail }}</a
                >.</div
              >
              <v-text-field
                v-model="name"
                class="name-input"
                color="blue"
                label="Name"
                :rules="[requiredStringRule]"
                large
                autofocus
              />
              <v-text-field
                v-model="email"
                color="blue"
                label="Email"
                large
                :rules="[requiredStringRule, emailRule]"
              />
              <v-textarea
                v-model="msgDetails"
                color="blue"
                label="Please tell us about your issue"
                large
                :counter="10"
                :counter-value="(v) => (!v.length ? 0 : v.match(/\S+/g).length)"
                auto-grow
                :rows="2"
                :rules="[requiredStringRule, msgDetailsLengthRule]"
              />

              <transition name="fade" mode="out-in">
                <div v-if="error" class="red--text">{{ error }}</div>
              </transition>

              <v-btn
                color="blue"
                :disabled="!isFormValid"
                @click="submitAction"
                depressed
                large
                block
                class="white--text mt-4"
                :loading="isSending"
                >Send Feedback</v-btn
              >
            </v-form>
          </transition>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import EmailService from '@/services/EmailService'
import _includes from 'lodash/includes'

export default {
  name: 'FeedbackView',
  data: () => {
    return {
      isFormValid: false,
      name: '',
      email: '',
      msgDetails: '',
      isSending: false,
      success: false,
      error: null,
      requiredStringRule: (v) => !!v.trim() || 'This field is required',
      msgDetailsLengthRule: (v) =>
        !v.length ||
        v.match(/\S+/g).length >= 10 ||
        'Please provide at least 10 words describing the issue',
      emailRule: (email) => {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(email) || 'Please enter a valid email'
      },
    }
  },
  computed: {
    ...mapGetters('shop', ['getShopTitle', 'getContactEmail']),
    ...mapGetters('customer', [
      'getCustomer',
      'getCustomerEmail',
      'getCustomerName',
    ]),
  },
  created() {
    if (this.getCustomerName) {
      this.name = this.getCustomerName
    }
    if (this.getCustomerEmail) {
      this.email = this.getCustomerEmail
    }
  },
  methods: {
    async submitAction() {
      if (!this.isFormValid) return

      this.isSending = true
      this.success = false
      this.error = false
      try {
        let { name, email } = this
        let res = await EmailService.sendFeedback({
          name,
          email,
          customer: JSON.stringify(this.getCustomer),
          storeName: this.getShopTitle,
          message: this.msgDetails,
        })
        this.success = true
        return res
      } catch (error) {
        this.error =
          'Something went wrong while sending your feedback. Please try again later.'
        return Promise.reject(Error(error))
      } finally {
        this.isSending = false
      }
    }, // submitAction

    resetForm() {
      this.success = false
      this.error = false
      this.msgDetails = ''
    }, // resetForm
    _includes,
  }, // methods
}
</script>
